import { GeoJson } from '@ais-ui/api-spec/shapes';

import { useShapesCreate } from '@ais-ui/api';
import { SaveShapeDialog } from './SaveShapeDialog';
import { DrawGeometryType } from '@ais-ui/react-openlayers';
import { Dispatch, SetStateAction } from 'react';

interface CreateShapeProps {
  setShowDialog: Dispatch<SetStateAction<boolean>>;
  geometryType: DrawGeometryType;
  shape?: GeoJson;
  startInDrawMode: boolean;
}

export function CreateShape({
  setShowDialog,
  geometryType,
  shape,
  startInDrawMode,
}: CreateShapeProps) {
  const { mutate } = useShapesCreate();

  return (
    <SaveShapeDialog
      setShowOuterDialog={setShowDialog}
      mutate={mutate}
      action="create"
      shape={shape}
      geometryType={geometryType}
      startInDrawMode={startInDrawMode}
    />
  );
}
